import { render, staticRenderFns } from "./PublicCoachSideNavLayout.vue?vue&type=template&id=7d3bac4a&"
import script from "./PublicCoachSideNavLayout.vue?vue&type=script&lang=ts&"
export * from "./PublicCoachSideNavLayout.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports